// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"Ex","blender_bottle_img":"Fx","blender_bottle_info":"Gx","blender_bottle_title":"Hx","blender_bottle_bold":"Ix","blender_bottle_usual":"Jx","blender_bottle_item_mob":"Kx","addbutton":"Lx","blender_bottle_title_mob":"Mx","blender_bottle_bold_mob":"Nx","blender_bottle_usual_mob":"Ox","bolder":"Px","bottom_margin_4":"Qx","bottom_margin_16":"Rx"};
    if(module.hot) {
      // 1713361650605
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  